import axios from "axios";
import { endpoints } from "Modules/files/api";

export const endpoint = `/api/file`;

export const getFileByUrl = (url) => {
  return axios.get(url, {
    responseType: "blob",
  });
};

export const getProtectedFileById = (id, password) =>
  axios.post(endpoints.getFileById(id), { password }, { responseType: "blob" });

export const uploadMedia = async (file) => {
  if (!file) return Promise.resolve(null);
  const { source } = file;
  if (source && !(source instanceof File)) return Promise.resolve(source);
  if (!source && !(file instanceof File)) return Promise.resolve(file);
  const fileData = file?.source instanceof File ? file.source : file;
  const form = new FormData();
  form.append("file", fileData); //binary
  form.append("name", file.name); //original file name
  return axios.post(endpoints.uploadFile, form).then((res) => res.data);
};
